import { css } from '@emotion/react'

import { breakpoints } from 'src/themes'

export const handsImageStyles = css`
  @media (max-width: ${breakpoints.widescreen}) {
    padding-bottom: 88%;
  }
`
